import { InsuranceInfo } from '@hb/shared'

const getMultipleEmployerComplete = (data: Partial<InsuranceInfo>): boolean =>
  !!data.planCoverageType &&
  !!data.reimbursementSystem &&
  !!data.reimbursementRate &&
  !!data.employmentOptionsFile &&
  !!data.coverageStartDate

const getMultipleOptionsComplete = (data: Partial<InsuranceInfo>): boolean => {
  if (!data.multipleOptionsDescription) return false
  switch (data.multipleOptionsDescription) {
    case 'multiple-employer':
      return getMultipleEmployerComplete(data)
    case 'other':
      return !!data.multipleOptionsOtherNotes
    case 'partner-individual':
      return data.confirmPartnerPlan !== undefined && data.confirmPartnerPlan !== null
    case 'partner-employer':
      return !!data.planToAssess
    default:
      return true
  }
}

export const getIsOptionDetailComplete = (data: Partial<InsuranceInfo>): boolean => {
  switch (data.option) {
    case 'coverage-will-change':
      return !!data.coverageWillChangeDescription
    case 'multiple-options':
      return getMultipleOptionsComplete(data)
    case 'no-coverage':
      return !!data.noCoverageDescription
    case 'not-pregnant':
      return !!data.notPregnantOption
    default:
      return true
  }
}
